<template>
  <el-row class="advantage_wrap">
    <el-col class="advantage_item" v-for="(item, index) in advantageList" :key="index" :span="5" :xs="11">
      <div class="item_top">
        <div class="icon">
          <icon :name="item.Icon" scale="1.2"></icon>
        </div>
        <div class="tit">{{ item.Title }}</div>
      </div>
      <ul class="item_desc hidden-xs-only" v-for="(desc, index2) in item.SubTitle" :key="index2">
        <li>{{ desc }}</li>
      </ul>
    </el-col>
  </el-row>
</template>

<script>
// 可用图标列表 - 完整列表 (共1000+个图标)
import availableIcons from '@/utils/icon-list'

// 预加载这些图标
availableIcons.forEach(iconName => {
  try {
    require(`vue-awesome/icons/${iconName}`)
  } catch (e) {
    console.warn(`Icon ${iconName} not found`)
  }
})

export default {
  props: {
    advantageList: {
      type: Array,
      default: [],
    }
  },
  methods: {
    // 确保图标已加载的辅助方法
    ensureIconLoaded(iconName) {
      // vue-awesome 会自动处理已加载的图标
      return iconName
    }
  }
}
</script>

<style lang="scss" scoped>
.advantage_wrap {
  width: 70%;
  display: flex;
  margin-top: 70px;
  justify-content: space-between;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }

  .advantage_item {
    height: auto;
    padding: 30px 20px 80px 20px;
    margin-right: 10px;
    background: url('../../assets/img/422c6817d7.png') 0 0 no-repeat;
    background-size: 100% 100%;

    @media screen and (max-width: 768px) {
      margin: 0;
      padding: 0 15px;
      margin-top: 3px;
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .item_top {
      display: flex;
      align-items: center;

      @media screen and (max-width: 768px) {
        height: 100px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      .icon {
        width: 15%;
        margin-right: 10PX;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;

          @media screen and (max-width: 768px) {
            margin-bottom: 10px;
            margin-left: 6px;
          }
        }
      }

      .tit {
        width: 100%;
        color: #1c1c1c;
        font-size: 22px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
    }

    .item_desc {
      font-size: 16px;
      line-height: 20PX;
      margin: 0;
      padding: 0;
      margin-top: 20px;
      padding-left: 34px;
      color: #646464;

      li {
        &:first-child {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>